import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { HorizontalAlignmentEnum, VerticalAlignmentEnum } from '@repo/ui/src/enums/shared-enums';
import { imageFullWidthXs } from '@repo/ui/src/styles/variables';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps, ToutContentProps } from '@repo/ui/src/types/';
import { classNames } from '@repo/ui/src/utils/classNames';

interface HalfWidthCardProps {
  toutContent: ToutContentProps;
  image: ImageProps;
  horizontalAlignment: HorizontalAlignmentEnum;
  verticalAlignment?: VerticalAlignmentEnum;
  onClick?: () => void;
  backgroundImageUrl: string;
  isVideo?: any;
  _testID?: string;
  index?: number;
  threeAcross?: boolean;
}
export const halfVerticalAlignmentClasses = {
  [VerticalAlignmentEnum.Top]: 'tw-justify-start',
  [VerticalAlignmentEnum.Center]: 'tw-justify-center',
  [VerticalAlignmentEnum.Bottom]: 'tw-justify-end',
};
export const halfHorizontalAlignmentClasses = {
  [HorizontalAlignmentEnum.Left]: 'tw-items-start',
  [HorizontalAlignmentEnum.Center]: 'tw-items-center',
  [HorizontalAlignmentEnum.Right]: 'tw-items-end',
};
const HalfWidthCard = ({
  toutContent,
  image,
  horizontalAlignment,
  verticalAlignment,
  onClick,
  isVideo,
  backgroundImageUrl,
  _testID,
  index,
  threeAcross,
}: HalfWidthCardProps) => {
  const imageUrl = buildImageSrc(image, imageFullWidthXs, 1, 1);

  return (
    <div
      className={classNames(
        'tw-bg-cover tw-bg-no-repeat tw-bg-center',
        isVideo ? 'tw-bg-none' : 'tw-bg-black',
        toutContent?.youtubeLink && 'tw-cursor-pointer',
      )}
      onClick={onClick}
      style={{
        backgroundImage: backgroundImageUrl ? `url("${backgroundImageUrl}")` : 'none',
      }}
      data-test-id={`half_width_card_${_testID}${index}`}
    >
      <div
        className={classNames(
          'tw-flex tw-flex-col tw-h-full tw-relative tw-flex-1 tw-p-6 tw-z-10 tw-bg-[rgba(0,0,0,0.55)]',
          threeAcross ? 'md:tw-p-14' : 'md:tw-p-16',
          image?.image
            ? 'tw-justify-around'
            : horizontalAlignment
              ? halfHorizontalAlignmentClasses[horizontalAlignment]
              : halfHorizontalAlignmentClasses[HorizontalAlignmentEnum.Center],
          verticalAlignment
            ? halfVerticalAlignmentClasses[verticalAlignment]
            : halfVerticalAlignmentClasses[VerticalAlignmentEnum.Center],
        )}
      >
        {image?.image && (
          <LazyLoadImage
            imgComponent={
              <img src={imageUrl} alt={image.image.name} className="tw-w-[70%] sm:tw-w-1/2" />
            }
            className="tw-flex tw-items-center tw-flex-col "
          />
        )}
        <ToutContent
          dark
          headingStyleVariant="h3"
          divider={!!toutContent.description}
          className="sm:[&_p]:tw-line-clamp-4 md:tw-max-w-[80%]"
          {...toutContent}
          buttonNegative
          align={horizontalAlignment}
        />
      </div>
    </div>
  );
};

export default HalfWidthCard;
